import { Box } from '@factorialco/deprecated-design-system'

import ClimateWidgetLaunch from 'modules/engagement_insights/components/ClimateWidget/Launch'
import ClimateWidgetStats from 'modules/engagement_insights/components/ClimateWidget/Stats'
import EnpsWidgetLaunch from 'modules/engagement_insights/components/EnpsWidget/Launch'
import EnpsWidgetStats from 'modules/engagement_insights/components/EnpsWidget/Stats'
import HelpCenterWidget from 'modules/engagement_insights/components/HelpCenterWidget'
import SmallHelpCenterWidget from 'modules/engagement_insights/components/SmallHelpCenterWidget'
import TurnoverRateWidget from 'modules/engagement_insights/components/TurnoverRateWidget'
import TurnoverWidgetComingSoon from 'modules/engagement_insights/components/TurnoverRateWidget/ComingSoon'
import { useEngagementInsightsData } from 'modules/engagement_insights/hooks/useEngagementInsightsData'

const StatsPage = () => {
  const { climate, enpsIsDraft, enps, canSeeTurnoverWidget } = useEngagementInsightsData()

  return (
    <Box gap="s24" flexDirection="row">
      {enpsIsDraft || !enps ? <EnpsWidgetLaunch /> : <EnpsWidgetStats />}
      {climate?.isDraft || !climate ? <ClimateWidgetLaunch /> : <ClimateWidgetStats />}

      <Box gap="s24" flexDirection="column" style={{ flex: '1 1 0' }}>
        {canSeeTurnoverWidget && (
          <>
            <TurnoverRateWidget />
            <HelpCenterWidget />
          </>
        )}
        {!canSeeTurnoverWidget && (
          <>
            <TurnoverWidgetComingSoon />
            <SmallHelpCenterWidget />
          </>
        )}
      </Box>
    </Box>
  )
}

export default StatsPage
